import React, { useState, useEffect } from 'react'
import useRefs from "react-use-refs";
import axios from 'axios';
import Products from './Products';
import { decodeToken } from "react-jwt";
import Dashboard from '../Dashboard';



function EditProduct({ productDetail }) {
    const token = localStorage.getItem("access_token");
    const decodedToken = decodeToken(token);
    const { REACT_APP_API_URL } = process.env;
    const [currentPage, setCurrentPage] = useState("");
    const [categories, setCategories] = useState([]);
    const [
        id,
        sku,
        name,
        price,
        discount,
        category,
        thumbnail

    ] = useRefs();

    const switchPage = (page) => {
        setCurrentPage(page);
    };

    const getAllCategories = async () => {
        let result = await axios.get(`${REACT_APP_API_URL}/get-categories`);
        setCategories(result.data);
    }

    const getCategoryNameById = () => {
        const name = categories.find(category => category.id === productDetail.product_categorie);
        return name?.category_name;
    }

    const getIdByCategoryName = (catName) => {
        const name = categories.find(category => category.category_name === catName);
        return name?.id;
    }

    useEffect(() => {
        getAllCategories();
    }, [])

    if (currentPage === "products") {
        return (<Products />)
    }

    const formData = new FormData();

    const handleSubmit = async (e) => {
        e.preventDefault();
        formData.append("id", id.current.value);
        formData.append("sku", sku.current.value);
        formData.append("name", name.current.value);
        formData.append("price", price.current.value);
        formData.append("discount", discount.current.value);
        formData.append("category", getIdByCategoryName(category.current.value));
        formData.append("thumbnail", thumbnail.current.value);
        try {
            const response = await axios.post(
                `${REACT_APP_API_URL}/update-product`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: "Bearer " + token
                    }
                }
            );
            if (response.status === 200) {
                setCurrentPage("products");
            }
        } catch (error) { }
    }
    if (decodedToken.role === 1) {
        return (
            <div className="container product-section">
                <div className="shop-section">
                    <button className='back-btn' onClick={() => switchPage("products")}>Back</button>
                    <div className="form-fields">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <input type="hidden" defaultValue={productDetail.id} ref={id} />
                            <label>SKU (Item-id)</label>
                            <input type="text" className="field" defaultValue={productDetail.sku} ref={sku} />
                            <label>Name</label>
                            <input type="text" className="field" defaultValue={productDetail.item_name} ref={name} />
                            <label>Price</label>
                            <input type="text" className="field" defaultValue={productDetail.item_price} ref={price} />
                            <label>Discount price</label>
                            <input type="text" className="field" defaultValue={productDetail.discount_price} ref={discount} required />
                            <label>Category</label>
                            <select style={{ display: 'block', marginBottom: '25px', marginTop: '10px' }} ref={category}>
                                {
                                    categories.map(category => {
                                        return (
                                            <option key={category.id} selected={getCategoryNameById() === category.category_name ? true : false}>{category.category_name}</option>
                                        )
                                    })
                                }
                            </select>
                            <label>Thumbnail</label>
                            <input type="text" className="field" defaultValue={productDetail.item_image} ref={thumbnail} />
                            <input className="login-btn" type="submit" value="Edit product" />
                        </form>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return (<Dashboard />)
    }
}

export default EditProduct